export enum SupplierAPIKeyStatusTypesEnum {
	"active" = 1,
	"inactive" = 2
}
